import type { Dayjs } from 'dayjs';

/**
 * Longest analytics window, in IST days, the backend accepts (`from` to `to`,
 * `to` exclusive). A longer one is refused with a 400.
 */
export const REPORT_MAX_DAYS = 92;

/** Days a picked range of calendar dates covers, both ends included. */
const pickedDays = (a: Dayjs, b: Dayjs): number =>
  Math.abs(b.startOf('day').diff(a.startOf('day'), 'day')) + 1;

/** True when the two picked dates (either order) make a window the backend accepts. */
export const isWithinReportCap = (a: Dayjs, b: Dayjs): boolean =>
  pickedDays(a, b) <= REPORT_MAX_DAYS;

/**
 * `disabledDate` for an antd RangePicker: once one end is picked (`info.from`),
 * days that would make the range longer than REPORT_MAX_DAYS are greyed out.
 * Before that every day is selectable.
 */
export const disabledBeyondReportCap = (current: Dayjs, info: { from?: Dayjs }): boolean =>
  info.from !== undefined && !isWithinReportCap(info.from, current);
